import React, { useState } from "react";
import Collapsible from "react-collapsible";

const ESSSummary = (props) => {
  const [IsOpen, setIsOpen] = useState(true);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  return (
    <div
      className={
        !IsOpen
          ? "summary-wrapper ess-summary"
          : "summary-wrapper ess-summary ess-summary-is-open"
      }
    >
      {window.innerWidth <= 450 ? (
        <>
          <Collapsible
            isOpen={IsOpen}
            onOpen={() => setIsOpen(true)}
            onClosing={() => setIsOpen(false)}
            open
            transitionTime={200}
            trigger={
              <div className="trigger">
                <p className="summary-title">
                  {translateText("total_statistics")}
                </p>
                <i
                  className={
                    IsOpen
                      ? "feather-chevron-down i-rotated"
                      : "feather-chevron-down"
                  }
                ></i>
              </div>
            }
          >
            <div className="summary-items">
              <section className="summary-item">
                <i className="feather-user-check"></i>
                <p className="count-info">
                  {props.AllApplicationsCount === NaN
                    ? null
                    : props.AllApplicationsCount}
                </p>
                <p className="smaill-info">
                  {translateText("all_applications")}
                </p>
              </section>
              <section className="summary-item">
                <i className="feather-eye"></i>
                <p className="count-info">{props.Review}</p>
                <p className="smaill-info">{translateText("review_stage")}</p>
              </section>
              <section className="summary-item">
                <i className="feather-message-circle"></i>
                <p className="count-info">{props.Interview}</p>
                <p className="smaill-info">
                  {translateText("interview_stage")}
                </p>
              </section>
              <section className="summary-item">
                <i className="feather-check-circle"></i>
                <p className="count-info">{props.FinalDecision}</p>
                <p className="smaill-info">
                  {translateText("jpa_action_stage_final_decision")}
                </p>
              </section>
            </div>
          </Collapsible>
        </>
      ) : (
        <>
          <p className="summary-title">{translateText("total_statistics")}</p>
          <div className="summary-items">
            <section className="summary-item">
              <i className="feather-user-check"></i>
              <p className="count-info">
                {props.AllApplicationsCount === NaN
                  ? null
                  : props.AllApplicationsCount}
              </p>
              <p className="smaill-info">{translateText("all_applications")}</p>
            </section>
            <section className="summary-item">
              <i className="feather-eye"></i>
              <p className="count-info">{props.Review}</p>
              <p className="smaill-info">{translateText("review_stage")}</p>
            </section>
            <section className="summary-item">
              <i className="feather-message-circle"></i>
              <p className="count-info">{props.Interview}</p>
              <p className="smaill-info">{translateText("interview_stage")}</p>
            </section>
            <section className="summary-item">
              <i className="feather-check-circle"></i>
              <p className="count-info">{props.FinalDecision}</p>
              <p className="smaill-info">
                {translateText("jpa_action_stage_final_decision")}
              </p>
            </section>
          </div>
        </>
      )}
    </div>
  );
};

export default ESSSummary;
